import script from "./InfoKontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoKontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./InfoKontraktorPage.vue?vue&type=style&index=0&id=511931a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511931a6"]])

export default __exports__